import { render } from "./ObjectiveAdd.vue?vue&type=template&id=31ed37f1&scoped=true"
import script from "./ObjectiveAdd.vue?vue&type=script&lang=js"
export * from "./ObjectiveAdd.vue?vue&type=script&lang=js"

import "./ObjectiveAdd.vue?vue&type=style&index=0&id=31ed37f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ed37f1"]])

export default __exports__